import React from 'react';

const CompareAddProductIcon = function() {
  return (
    <svg
      className={'add_product_icon'}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="#000000"
        d="M2 12c0-4.714 0-7.071 1.464-8.536C4.93 2 7.286 2 12 2s7.071 0 8.535 1.464C22 4.93 22 7.286 22 12s0 7.071-1.465 8.535C19.072 22 16.714 22 12 22s-7.071 0-8.536-1.465C2 19.072 2 16.714 2 12Z"
      ></path>
      <path stroke="#000000" strokeLinecap="round" d="M15 12h-3m0 0H9m3 0V9m0 3v3"></path>
    </svg>
  );
};

export default CompareAddProductIcon;